import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../../api';
import { FaInstagram, FaLinkedinIn, FaTelegram } from 'react-icons/fa';
import { BsChatFill } from 'react-icons/bs';
import { contactsData } from '../../data/contactsData';
import { socialsData } from '../../data/socialsData';
import './Contacts.css';

const LINKS = [
    { label: contactsData.link1, to: '/beauty' },
    { label: contactsData.link2, to: '/service/5' },
    { label: contactsData.link3, to: '/cosmetics' },
    { label: contactsData.link4, to: '/service/5' },
    { label: contactsData.link5, to: '/education' },
    { label: contactsData.link6, to: '/contact' },
];

function Contacts() {
    const [articles, setArticles] = useState([]);

    useEffect(() => {
        api.get('/api/products/')
            .then(r => {
                const sorted = [...r.data].sort((a, b) => new Date(b.pub_date) - new Date(a.pub_date));
                setArticles(sorted.slice(0, 3));
            })
            .catch(() => {});
    }, []);

    return (
        <footer className="ct-footer" id="contacts">
            <div className="ct-grid">

                {/* ── ستون شرکت ── */}
                <div className="ct-brand">
                    <div className="ct-brand__logo-wrap">
                        <img
                            src={require('../../assets/image/lego1.webp')}
                            alt="دکتر سیمین"
                            className="ct-brand__logo"
                        />
                        <div>
                            <h3 className="ct-brand__name">دکتر سیمین</h3>
                            <p className="ct-brand__tagline">ایده، تولید، بازاریابی</p>
                        </div>
                    </div>
                    <div className="ct-brand__divider" />
                    <p className="ct-brand__desc">
                        شرکت دکتر سیمین با رویکردی جامع و حرفه‌ای، از مرحله ایده‌پردازی اولیه تا تولید، اجرا و بازاریابی، در تمامی بخش‌های حوزه آرایشی، بهداشتی و زیبایی فعالیت می‌کند. متخصصان این شرکت با شناخت دقیق از نیاز بازار و ترندهای جهانی به برندها، کلینیک‌ها و متخصصان این حوزه کمک می‌کنند تا ایده‌های نوآورانه خود را به محصولات و خدماتی موفق، ایمن و رقابتی تبدیل کنند.
                    </p>

                    {/* ── نماد اینماد ── */}
                    <a
                        referrerPolicy="origin"
                        target="_blank"
                        href="https://trustseal.enamad.ir/?id=602798&Code=9X0ygreoy10xxdggbPJgkth479HD8ftQ"
                        rel="noreferrer"
                        className="ct-enamad"
                    >
                        <img
                            referrerPolicy="origin"
                            src="https://trustseal.enamad.ir/logo.aspx?id=602798&Code=9X0ygreoy10xxdggbPJgkth479HD8ftQ"
                            alt="نماد اعتماد الکترونیکی"
                            code="9X0ygreoy10xxdggbPJgkth479HD8ftQ"
                        />
                    </a>
                </div>

                {/* ── ستون لینک‌ها ── */}
                <div className="ct-links">
                    <h4 className="ct-links__title">لینک‌های مفید</h4>
                    <ul className="ct-links__list">
                        {LINKS.map((l, i) => (
                            <li key={i}>
                                <Link to={l.to}>
                                    <span className="ct-links__dot" />
                                    {l.label}
                                </Link>
                            </li>
                        ))}
                    </ul>
                </div>

                {/* ── ستون سوشال ── */}
                <div className="ct-social">
                    <h4 className="ct-social__title">مقالات تخصصی</h4>

                    {articles.length > 0 && (
                        <ul className="ct-articles">
                            {articles.map(a => (
                                <li key={a.id}>
                                    <Link to={`/product/${a.id}`} className="ct-article__link">
                                        <span className="ct-links__dot" />
                                        {a.title}
                                    </Link>
                                </li>
                            ))}
                        </ul>
                    )}

                    <div className="ct-social__icons">
                        {socialsData.instagram && (
                            <a href={socialsData.instagram} target="_blank" rel="noreferrer" className="ct-social__icon ct-social__icon--instagram">
                                <FaInstagram />
                                <span>اینستاگرام</span>
                            </a>
                        )}
                        {socialsData.telegram && (
                            <a href={socialsData.telegram} target="_blank" rel="noreferrer" className="ct-social__icon ct-social__icon--telegram">
                                <FaTelegram />
                                <span>تلگرام</span>
                            </a>
                        )}
                        {socialsData.linkedIn && (
                            <a href={socialsData.linkedIn} target="_blank" rel="noreferrer" className="ct-social__icon ct-social__icon--linkedin">
                                <FaLinkedinIn />
                                <span>لینکدین</span>
                            </a>
                        )}
                        {socialsData.bale && (
                            <a href={socialsData.bale} target="_blank" rel="noreferrer" className="ct-social__icon ct-social__icon--bale">
                                <BsChatFill />
                                <span>بله</span>
                            </a>
                        )}
                    </div>
                </div>

            </div>

            {/* ── کپی‌رایت ── */}
            <div className="ct-bottom">
                <p className="ct-bottom__copy">© ۱۴۰۴ شرکت دکتر سیمین — تمامی حقوق محفوظ است</p>
                <Link to="/privacy" className="ct-bottom__privacy">حریم خصوصی</Link>
            </div>
        </footer>
    );
}

export default Contacts;
